import React from 'react';
import Loadable from 'react-loadable';

const Cookie = Loadable({
  loader: () => new Promise((resolve) => { setTimeout(() => { resolve(import('./index.lazy')); }, 5000); }),
  loading: () => (<div />),
});

export default Cookie;
